import React, { FunctionComponent, useContext, useEffect, useState } from 'react';
import { RootStoreContext } from "../../../stores/RootStore";

import { TrashIcon } from "@heroicons/react/24/solid";
import { observer } from "mobx-react-lite";
import { arraySum, displayDate, displayDollarAmount } from "../../../lib/utilities";
import { IInstallation } from "../../../models/Installation/Installation";
import Table from '../../table/Table';
import TBody from '../../table/TBody';
import TD from '../../table/TD';
import THead from '../../table/THead';
import TR from '../../table/TR';
import InstallationAutoCompleteInput from "../InstallationAutoCompleteInput";

interface OwnProps {
  onChange?: (e) => (void)
  name?: string
  selected?: string[]
  entityStateId?: string
}

type Props = OwnProps;

const InstallationMultiselect: FunctionComponent<Props> = ({entityStateId, onChange, name, selected}) => {
  //Stores
  const rootStore = useContext(RootStoreContext);
  const {newSubItemQueue} = rootStore.subItemStore

  // Local State
  const [availableInstallations, setAvailableInstallations] = useState([] as IInstallation[]);
  const [selectedInstallations, setSelectedInstallations] = useState([] as Array<IInstallation>);

  // Use Effects
  const findInstallationById = (id: string)  => availableInstallations.find(x=> x.id === id)
  useEffect(() => {
    if (!!selected && selected?.length > 0) {
      selected.forEach(id => {
        const data = findInstallationById(id)
        if (!!data) setSelectedInstallations(prev => [...prev, data])
      })
    }
  }, [availableInstallations, newSubItemQueue]);


  // Functions
  const handleRemove = (idx): void => {
    setSelectedInstallations((prev) => {
      const tmp = [ ...prev ]
      tmp.splice(idx, 1)
      !!onChange && onChange({
        currentTarget: {
          name,
          value: tmp.map(ids => ids?.id)
        }
      })
      return tmp
    })
  }

  const handleSelected = (data): void => {
    if (!!data) {
      let newInstallation = availableInstallations
      .find((installation: IInstallation) => installation.id === data.id)

      if (!newInstallation) return

      // @ts-ignore
      setSelectedInstallations(prev => {
        let tmp = [...prev, newInstallation]
        // let tmp = [...prev]
        !!onChange && onChange({
          currentTarget: {
            name,
            value: tmp.map(ids => ids?.id)
          }
        })
        return tmp
      })
    }
  }

  return (<>
    <div className={'grid grid-cols-1 sm:grid-cols-1 gap-x-4 gap-y-1'}>
      <InstallationAutoCompleteInput
        onFetchSuccess={setAvailableInstallations}
        entityStateId={entityStateId}
        onChange={handleSelected}
        // @ts-ignore
        filterIds={selectedInstallations?.map((select: IInstallation) => {return !!select ? select.id : ''}) ?? []}
      />
    </div>

    <Table>
      <THead>
        <TR>
          <TD/>
          <TD>Consumer</TD>
          <TD>Technician</TD>
          <TD>Date Performed</TD>
          <TD>Date Requested</TD>
          <TD>Total Cost</TD>
        </TR>
      </THead>
      <TBody>
        {selectedInstallations.map((installation: IInstallation, idx) => {
          return (<TR key={idx}>
            <TD><TrashIcon className={'text-red-600 h-6 w-6'} onClick={() => handleRemove(idx)}/></TD>
            <TD>{installation?.consumerName}</TD>
            <TD>{installation?.technicianName}</TD>
            <TD>{displayDate(installation?.datePerformed)}</TD>
            <TD>{displayDate(installation?.dateRequested)}</TD>
            <TD>{displayDollarAmount(arraySum([
              installation?.installationLaborCosts,
              installation?.instructionalMaterialCosts,
              installation?.auxiliaryAidCosts,
              installation?.otherExpenses,
            ]))}</TD>
          </TR>)
        })}
      </TBody>
    </Table>
  </>);
};

export default observer(InstallationMultiselect);
